export enum ECOMPANY_ROLE {
  ACCOUNT = 0,
  MANAGER = 1,
  OPERATION_MANAGER = 2,
  RECEPTION = 3,
  OWNER = 4,
  OTHER = 5
}
